<template>
  <transition name="slide">
    <div
      v-show="showUserCard"
      class="user-card-container"
      @mouseleave="hideCard"
      @click.stop
    >
      <div class="user-card">
        <div class="user-card__profile">
          <button type="button" class="user-card__identity" @click="goToUserCenter">
            <span class="user-card__avatar">
              <img :src="user.avatar" :alt="`${user.name}的头像`" />
            </span>
            <span class="user-card__identity-text">
              <strong class="user-card__name">{{ user.name }}</strong>
              <span class="user-card__enter">
                进入个人中心
                <AppIcon
                  name="chevronRight"
                  size="xs"
                  class="user-card__enter-chevron"
                  aria-hidden="true"
                />
              </span>
            </span>
          </button>
          <button
            type="button"
            class="user-card__logout"
            aria-label="退出登录"
            @click.stop="handleLogout"
          >
            <AppIcon name="logout" size="sm" aria-label="退出登录" />
          </button>
        </div>

        <button
          type="button"
          class="user-card__wallet"
          @click="navigateTo('PurchaseHistory')"
        >
          <span class="user-card__wallet-head">
            <span class="user-card__wallet-title">
              <AppIcon name="wallet" size="lg" class="user-card__wallet-icon" aria-hidden="true" />
              <strong>我的钱包</strong>
            </span>
            <small class="user-card__wallet-detail">钱包明细</small>
          </span>
          <span class="user-card__wallet-stats">
            <span>
              <small>当前余额</small>
              <span class="user-card__stat-value">
                <AppIcon name="orangeCoin" size="md" aria-hidden="true" />
                <strong>{{ goldAmount }}</strong>
              </span>
            </span>
            <span>
              <small>累计消费</small>
              <span class="user-card__stat-value">
                <AppIcon name="totalSpend" size="md" aria-hidden="true" />
                <strong>{{ totalConsumeAmount }}</strong>
              </span>
            </span>
          </span>
        </button>

        <div class="user-card__shortcuts">
          <button type="button" @click="navigateTo('UserFavorites')">
            <AppIcon name="heart" size="md" />
            <span>我的收藏</span>
          </button>
          <button type="button" @click="navigateTo('UserHistory')">
            <AppIcon name="history" size="md" />
            <span>观看记录</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import AppIcon from '@/shared/components/AppIcon.vue'
import { useUserCard } from '@/features/user/composables/useUserCard'

const props = defineProps({
  showUserCard: {
    type: Boolean,
    required: true,
  },
  user: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['hide', 'logout'])

const {
  goldAmount,
  totalConsumeAmount,
  hideCard,
  goToUserCenter,
  navigateTo,
  handleLogout,
} = useUserCard(props, emit)
</script>

<style scoped src="@/features/user/styles/UserCard.css"></style>
